export const navBarData = [
    { name: "Home", path: "" },
    { name: "Tales of Startups", path: "tales-of-startups" },
    { name: "Infographics", path: "infographics" },
    { name: "Glossary", path: "glossary" },
    { name: "Blogs", path: "blogs" },
    { name: "Contact us", path: "contact-us" },
  ];